/**
 * Position Helpers
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Computes absolute element position which is relative to a parent
 * @param targetEl
 * @param parentEl
 * @returns
 */
export function getAbsElementPositionWithinParent(
	targetEl: HTMLElement,
	parentEl: HTMLElement
): {
	x: number;
	y: number;
} {
	const targetRect = targetEl.getBoundingClientRect();
	const parentRect = parentEl.getBoundingClientRect();

	return {
		x: targetRect.x - parentRect.x,
		y: targetRect.y - parentRect.y
	};
}
